'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffers = exports.triggerBonusByPromoCode = exports.preclaimBonus = exports.cancelBonus = exports.rejectBonus = exports.claimBonus = exports.getPendingBonuses = exports.getMonetaryBonuses = exports.getFreeSpins = exports.getBonusById = exports.getBonuses = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('./utils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ft2tg = function ft2tg(_ref, status) {
  var Type = _ref.Type,
      BonusCode = _ref.BonusCode,
      bonus = _objectWithoutProperties(_ref, ['Type', 'BonusCode']);

  return _extends({}, bonus, {
    Provider: 'fasttrack',
    State: status,
    Identifier: bonus.Reference,
    Name: bonus.Description,
    Description: bonus.Description,
    Created: new Date(bonus.DateCreated + '+00:00'),
    Initiated: new Date(bonus.DateCreated + '+00:00'),
    Ended: new Date(bonus.DateConsumed + '+00:00'),
    Expires: new Date(bonus.ExpiryDate + '+00:00'),
    Type: bonus.Custom && bonus.Custom.Type || 'Monetary',
    Amount: bonus.Custom && bonus.Custom.Amount || 0,
    Currency: bonus.Custom && bonus.Custom.Currency || 'EUR',
    PromoCode: BonusCode,
    GameProps: [{
      Id: bonus.MobileGameId,
      Name: bonus.MobileGameSlug
    }, {
      Id: bonus.DesktopGameId,
      Name: bonus.DesktopGameSlug
    }],
    Games: [bonus.MobileGameId, bonus.DesktopGameSlug],
    FTType: Type,

    // Promotion from FT instead of contentful
    promotion: {
      content: bonus.Description,
      identifier: bonus.Reference,
      image: {
        file: {
          url: bonus.ImageUrl
        }
      },
      summary: bonus.Description,
      termsAndConditions: bonus.Description,
      disclaimer: bonus.TermsAndConditions,
      shortDisclaimer: bonus.Custom && bonus.Custom.ShortTerms
    }
  });
};

/**
 * Get a list of all bonuses (pending, active, expired, cleared)
 * @param {string} playerSessionID
 */
var getBonuses = exports.getBonuses = function getBonuses(playerSessionID) {
  return new Promise(function (resolve, reject) {
    (0, _utils.getFastTrackSid)(playerSessionID).then(function () {
      if (typeof FasttrackCrm === 'undefined') return reject();

      Promise.all([(0, _utils.getProtected)('/bonus', playerSessionID), FasttrackCrm.getPendingBonuses()]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            aleacc = _ref3[0],
            pending = _ref3[1];

        var pRes = (pending || []).map(function (b) {
          return ft2tg(b, 'Initiated');
        }); // Initiated so it gets in the Available group.
        var aRes = aleacc.data || [];

        return resolve({ data: [].concat(_toConsumableArray(pRes), _toConsumableArray(aRes)) });
      });
    });
  });
};

/**
 * Get detailed information for a specific bonus
 * @param {string} playerSessionID
 * @param {string} bonusId Id of the bonus to retrieve, the bonus must be belong to the authenticated player
 */
var getBonusById = exports.getBonusById = function getBonusById(playerSessionID, bonusId) {
  return new Promise(function (resolve, reject) {
    getBonuses(playerSessionID).then(function (bonuses) {
      resolve({ data: bonuses.find(function (b) {
          return b.Id == bonusId;
        }) });
    });
  });
};

/**
 * Get a list of all freespins (excluding pending) BonusAmount is the number of freespins awarded until they have been played at which point the value is the amount won on the freespins
 * @param {string} playerSessionID
 */
var getFreeSpins = exports.getFreeSpins = function getFreeSpins(playerSessionID) {
  return new Promise(function (resolve, reject) {
    getBonuses(playerSessionID).then(function (res) {
      resolve(res);
    });
  });
};

/**
 * Get a list of all monetary bonuses (excluding pending)
 * @param {string} playerSessionID
 */
var getMonetaryBonuses = exports.getMonetaryBonuses = function getMonetaryBonuses(playerSessionID) {
  return new Promise(function (resolve, reject) {
    getBonuses(playerSessionID).then(function (res) {
      resolve(res);
    });
  });
};

/**
 * Get a list of all pending bonuses
 * @param {string} playerSessionID
 */
var getPendingBonuses = exports.getPendingBonuses = function getPendingBonuses(playerSessionID) {
  return new Promise(function (resolve, reject) {
    (0, _utils.getFastTrackSid)(playerSessionID).then(function () {
      if (typeof FasttrackCrm === 'undefined') return reject();

      Promise.all([(0, _utils.getProtected)('/bonus/pending', playerSessionID), FasttrackCrm.getPendingBonuses()]).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            aleacc = _ref5[0],
            pending = _ref5[1];

        var pRes = (pending || []).map(function (b) {
          return ft2tg(b, 'Initiated');
        }); // Initiated so it gets in the Available group.
        var aRes = aleacc.data || [];

        return resolve({ data: [].concat(_toConsumableArray(pRes), _toConsumableArray(aRes)) });
      });
    });
  });
};

/**
 * Claim a pending bonus
 * @param {string} playerSessionID
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var claimBonus = exports.claimBonus = function claimBonus(playerSessionID, bonusId) {
  return FasttrackCrm.consumePendingReward(bonusId);
};

/**
 * Reject a pending bonus
 * @param {string} playerSessionID
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var rejectBonus = exports.rejectBonus = function rejectBonus(playerSessionID, bonusId) {
  return (0, _utils.postProtected)('/bonus/reject/' + bonusId, playerSessionID);
};

/**
 * Cancel a pending bonus
 * @param {string} playerSessionID
 * @param {string} bonusId Id of the bonus to claim, the bonus must be belong to the authenticated player
 */
var cancelBonus = exports.cancelBonus = function cancelBonus(playerSessionID, bonusId) {
  return (0, _utils.postProtected)('/bonus/cancel/' + bonusId, playerSessionID);
};

/**
 * Preclaim a bonus using promo code
 * @param {string} playerSessionID
 * @param {string} promoCode
 */
var preclaimBonus = exports.preclaimBonus = function preclaimBonus(playerSessionID, promoCode) {
  return FasttrackCrm.consumePendingReward(promoCode);
};

/**
 * Trigger a bonus manually using a promo code. The bonus has to be configured with the trigger type PromotionCode
 * @param {string} playerSessionID
 * @param {string} promoCode
 */
var triggerBonusByPromoCode = exports.triggerBonusByPromoCode = function triggerBonusByPromoCode(playerSessionID, promoCode) {
  return FasttrackCrm.consumePendingReward(promoCode);
};

/**
 * Get a list of all available offers for a specific trigger type. Note: Currently only type = deposit is supported
 * @param {string} playerSessionID
 */
var getOffers = exports.getOffers = function getOffers(playerSessionID) {
  return new Promise(function (resolve, reject) {
    (0, _utils.getFastTrackSid)(playerSessionID).then(function () {
      if (typeof FasttrackCrm === 'undefined') return reject();

      FasttrackCrm.getPendingBonuses().then(function (pending) {
        var pRes = (pending || []).map(function (b) {
          return ft2tg(b, 'Initiated');
        }); // Initiated so it gets in the Available group.
        return resolve({ data: pRes });
      });
    });
  });
};

exports.default = {
  getBonuses: getBonuses,
  getBonusById: getBonusById,
  getFreeSpins: getFreeSpins,
  getMonetaryBonuses: getMonetaryBonuses,
  getPendingBonuses: getPendingBonuses,
  claimBonus: claimBonus,
  rejectBonus: rejectBonus,
  cancelBonus: cancelBonus,
  preclaimBonus: preclaimBonus,
  triggerBonusByPromoCode: triggerBonusByPromoCode,
  getOffers: getOffers
};